import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { WorkflowStatusChange } from "src/app/shared/models/workflow";
import { NotificationService } from "src/app/shared/services/notification.service";
import { PublicSurveyService } from "src/app/shared/services/public-survey.service";
import { WorkflowService } from "src/app/shared/services/workflow.service";

@Component({
    selector: "app-survey-workflow-bar",
    templateUrl: "./survey-workflow-bar.component.html",
    styleUrls: ["./survey-workflow-bar.component.scss"],
    standalone: false
})
export class SurveyWorkflowBarComponent implements OnInit {
  @Input() surveyCompleted: boolean = false;
  @Input() surveyIsOpen: boolean = true;
  @Input() administrativeUnitSurveyId?: string;
  @Input() indicatorType: number;
  @Input() language: string;
  @Input() isEditing?: boolean = false;
  @Input() workFlowId?: string;
  @Input() statusChanges: WorkflowStatusChange[] = [];
  @Output() statusChanged = new EventEmitter();

  constructor(
    private publicSurveyService: PublicSurveyService,
    private workFlowService: WorkflowService,
    private router: Router,
    private notificationService: NotificationService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.load();
  }

  async load() {
    if (this.statusChanges.length === 0) {
      if (!this.isEditing) {
        if (this.administrativeUnitSurveyId)
          this.statusChanges = await this.publicSurveyService
            .getAvailableStatusChanges(this.administrativeUnitSurveyId, this.language)
            .toPromise();
      } else {
        this.statusChanges = await this.workFlowService
          .getStatuseChanges(this.workFlowId)
          .toPromise();
      }
    }
  }

  async moveToStatus(workflowStatusId: string) {
    if (this.router.url.includes("public")) {
      await this.publicSurveyService
        .changeSurveyStatus(
          this.workFlowId,
          this.administrativeUnitSurveyId,
          workflowStatusId,
          this.indicatorType,
          this.language
        )
        .toPromise();
    } else {
      await this.workFlowService
        .changeSurveyStatus(
          this.workFlowId,
          this.administrativeUnitSurveyId,
          workflowStatusId,
          this.indicatorType,
          this.language
        )
        .toPromise();
    }

    this.notificationService.success("Status changed successfully");

    this.statusChanged.emit();
    this.statusChanges = [];
    await this.load();
  }

  isDisabled(item: WorkflowStatusChange) {
    return (
      (!this.surveyIsOpen && item.surveyMustBeOpen) ||
      (!this.surveyCompleted && item.allQuestionsAnswered)
    );
  }

  getButtonStyle(item: WorkflowStatusChange) {
    return `background-color:${item.buttonBackgroundColor}; color: ${item.buttonFontColor};`;
  }
}
